<template>
  <div class="service-container">
    <ServiceNav id="service-nav"></ServiceNav>
    <router-view id="change-view"></router-view>
  </div>
</template>

<script>
import ServiceNav from "@/components/service/service_nav.vue";

export default {
  name: "service",
  components: {
    ServiceNav,
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-container {
  display: flex;
  flex-wrap: nowrap;
  padding: 140px 70px 60px 70px;
  @include betweenPhoneTable {
    flex-wrap: wrap;
    padding: 140px 15px;
  }
}
#service-nav {
  flex: 0 0 23.3%;
  min-width: 147px;
  margin-right: 2.8%;
  @include betweenPhoneTable {
    flex: 1 0 auto;
    min-width: 303px;
    margin-right: 0;
  }
  @include phone {
    min-width: 273px;
  }
}
#change-view {
  flex: 1 0 auto;
  @include phone {
    flex: 1 0 273px;
  }
}
</style>
